var _defs, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.001,
    height: 51.026,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.308
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#232525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#7a8182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0dcdd"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1560"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1559"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1557"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 994",
    d: "m116.75 13.745-2.348 1.8a13.229 13.229 0 0 0-10.777-5.2 12.8 12.8 0 0 0-9.246 3.774 12.4 12.4 0 0 0-3.879 9.246 12.194 12.194 0 0 0 3.795 9.141 13.116 13.116 0 0 0 9.5 3.669 13.389 13.389 0 0 0 10.609-4.948l2.348 1.8a14.3 14.3 0 0 1-5.619 4.466 18.058 18.058 0 0 1-7.506 1.53 15.973 15.973 0 0 1-11.741-4.528 15.44 15.44 0 0 1-4.571-11.448 15.4 15.4 0 0 1 2.118-7.9 15 15 0 0 1 5.871-5.682 16.55 16.55 0 0 1 8.072-2.055 17.841 17.841 0 0 1 7.757 1.635 14.354 14.354 0 0 1 5.617 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 995",
    d: "M126.478 8.171h5.913v30.108h-2.977v-27.17h-4.738z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 996",
    d: "M145.18 38.279V8.171h6.247a34.078 34.078 0 0 1 9.414.944 13.369 13.369 0 0 1 5.179 2.977 13.609 13.609 0 0 1 3.355 4.969 18.393 18.393 0 0 1 1.174 6.856 15.588 15.588 0 0 1-1.822 7.38 12.51 12.51 0 0 1-4.948 5.221q-3.124 1.761-8.995 1.761zm2.893-2.852h3.481a40.472 40.472 0 0 0 7.9-.545 9.568 9.568 0 0 0 4.3-2.159 10.54 10.54 0 0 0 2.809-3.921 13.6 13.6 0 0 0 .964-5.284 13.454 13.454 0 0 0-1.111-5.493 10.778 10.778 0 0 0-3.166-4.152 11.238 11.238 0 0 0-4.843-2.2 44.258 44.258 0 0 0-8.2-.566h-2.139z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 997",
    d: "M174.658 23.35a16.013 16.013 0 0 1 2.1-8.051 15.231 15.231 0 0 1 5.745-5.787 15.672 15.672 0 0 1 7.946-2.1 16.142 16.142 0 0 1 8.009 2.076 15.146 15.146 0 0 1 5.828 5.745 16.116 16.116 0 0 1 .021 15.935 15.226 15.226 0 0 1-5.766 5.766 15.781 15.781 0 0 1-7.967 2.1 16.025 16.025 0 0 1-7.988-2.076 15.227 15.227 0 0 1-5.807-5.724 15.431 15.431 0 0 1-2.121-7.884zm28.6-.126a12.779 12.779 0 0 0-12.79-12.873 12.055 12.055 0 0 0-9.037 3.753 12.664 12.664 0 0 0-3.627 9.141 12.729 12.729 0 1 0 25.454-.021z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 998",
    d: "M216.088 8.171h5.913v30.108h-2.977v-27.17h-4.738z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1558"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 999",
    d: "m72.284 25.446-.353-.35-1.069-1.061-16.707-16.57A25.319 25.319 0 0 0 36.134-.004a25.412 25.412 0 0 0-18.251 7.7L1.416 24.163 0 25.579l.351.348 1.071 1.064 16.707 16.57a25.318 25.318 0 0 0 18.021 7.465 25.412 25.412 0 0 0 18.249-7.7l16.474-16.463 1.416-1.416zM20.073 41.608 3.909 25.572 19.842 9.638l.013-.013a22.726 22.726 0 0 1 32.353-.208l16.165 16.037-15.93 15.933-.013.013a22.726 22.726 0 0 1-32.357.208z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1000",
    d: "M40.292 39.894a15.13 15.13 0 0 0-2.776-29.613v32.885l-.116.009a14.5 14.5 0 0 1-1.033.029c-.72 0-1.433-.027-1.478-.029a17.925 17.925 0 0 1-16.62-17.83 17.718 17.718 0 0 1 3.616-10.78 17.9 17.9 0 0 1 4.819-4.392l.035-.022a15.867 15.867 0 0 1 5.25-2.2v2.856a12.369 12.369 0 0 0-1.865.656 15.248 15.248 0 0 0-6.049 4.758 15.136 15.136 0 0 0 10.694 24.186V7.473h1.373a17.876 17.876 0 0 1 4.15 35.26z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1001",
    d: "M119.125 150.145a15.029 15.029 0 0 1-5.125-1.407l-1.942 2.088a17.7 17.7 0 0 0 7.064 2.073z",
    transform: "translate(-84.356 -109.734)",
    style: {
      fill: "url(#a)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new_logo.6ca3b8fae8051ee77ffc8b44cf602741.svg";
export { ForwardRef as ReactComponent };